import { getConfig } from "./config.service";
import { ApiResult } from "../shared/networking/api_result";
import HttpService from "../shared/networking/http_service";
import { IAuthData } from "models/authentication";

export class AuthServiceAPI extends HttpService {
  public async fetchAuthData(): Promise<ApiResult<IAuthData>> {
    return this.getAnonym<IAuthData>(`/account/user`);
  }
}

const appConfig = getConfig();
const TimeoutMilliseconds = Number(appConfig.httpTimeoutMs);
const AuthService = new AuthServiceAPI(TimeoutMilliseconds);

export default AuthService;
